export const DossierType = {
  Affare: '1',
  Attivita: '2',
  PersonaFisica: '3',
  PersonaGiuridica: '4',
  ProcedimentoAmministrativo: '5'
};
